<template>
  <div class="plan-list-page">
    <my-nav-bar v-if="showAppBar" :title="'训练方案'" back @onBackClick="onBack"/>
    <container-list :empty="empty" :empty-desc="'暂无训练方案'" :loading="loading&&(datas.length===0)">
      <div class="plan-list-page__content">
        <van-pull-refresh v-model="refreshing" @refresh="loadDatas">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="已加载全部方案"
            @load="httpDatas"
          >
            <!-- 统计信息卡片 -->
            <div class="plan-list-page__stats" v-if="datas.length > 0">
              <div class="stats-card">
                <div class="stats-card__icon">
                  <van-icon name="records" size="20" color="#fff"/>
                </div>
                <div class="stats-card__info">
                  <div class="stats-card__value">{{ datas.length }}</div>
                  <div class="stats-card__label">训练方案</div>
                </div>
                <div v-if="vipInfo" class="stats-card__vip">
                  <div class="stats-card__vip-label">康复服务有效期</div>
                  <div class="stats-card__vip-value">{{ formatVipExpireDate(vipInfo.endTime) }}</div>
                  <div class="stats-card__vip-days">剩余{{ remainingDays }}天</div>
                </div>
              </div>
            </div>

            <!-- 方案列表 -->
            <div class="plan-list-page__list">
              <div
                v-for="(item,index) in datas"
                :key="index"
                class="plan-item"
                @click="onItemClick(item)"
              >
                <!-- 最新标签 -->
                <div v-if="index === 0" class="plan-item__badge">
                  <van-tag type="success" size="medium" round>最新方案</van-tag>
                </div>

                <!-- 卡片内容 -->
                <div class="plan-item__card">
                  <!-- 左侧图标区域 -->
                  <div class="plan-item__icon-wrapper">
                    <div class="plan-item__icon">
                      <van-icon name="description" size="32" color="#fff"/>
                    </div>
                  </div>

                  <!-- 右侧内容区域 -->
                  <div class="plan-item__content">
                    <!-- 标题 -->
                    <div class="plan-item__title">
                      {{ item.plan.planTitle }}
                    </div>

                    <!-- 信息行 -->
                    <div class="plan-item__info">
                      <div class="info-item">
                        <van-icon name="manager" size="14" color="#999"/>
                        <span class="info-item__text">定制医生：{{ item.doctorName }}</span>
                      </div>
                      <div class="info-item" v-if="item.doctorInfo && (item.doctorInfo.institution || item.doctorInfo.office)">
                        <van-icon name="location" size="14" color="#999"/>
                        <span class="info-item__text">
                          <span v-if="item.doctorInfo.institution">{{ item.doctorInfo.institution }}</span>
                          <span v-if="item.doctorInfo.institution && item.doctorInfo.office"> - </span>
                          <span v-if="item.doctorInfo.office">{{ item.doctorInfo.office }}</span>
                        </span>
                      </div>
                      <div class="info-item">
                        <van-icon name="clock" size="14" color="#999"/>
                        <span class="info-item__text">{{ item.gmtCreate }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- 右侧箭头 -->
                  <div class="plan-item__arrow">
                    <van-icon name="arrow" color="#c8c9cc"/>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </container-list>
  </div>
</template>

<script>
import MyNavBar from '../../components/MyNavBar'
import ContainerList from '../../components/ContainerList'
import PlanDao from '../../network/PlanDao'
import DoctorUserDao from '../../network/DoctorUserDao'
import VipDao from '../../network/VipDao'
import DateUtils from '../../../../utils/DateUtils'

export default {
  name: 'PlanListPage',
  components: {
    ContainerList,
    MyNavBar
  },
  data () {
    return {
      empty: true,
      loading: true,
      finished: false,
      refreshing: false,
      datas: [],
      showAppBar: true,
      phone: '',
      vipInfo: null,
      isVipLoading: false
    }
  },
  computed: {
    remainingDays () {
      if (!this.vipInfo || !this.vipInfo.endTime) return 0
      try {
        const normalizeTimestamp = (ts) => {
          if (!ts) return 0
          const num = Number(ts)
          return num < 1e12 ? num * 1000 : num
        }

        const endTime = normalizeTimestamp(this.vipInfo.endTime)
        const now = Date.now()
        const diff = endTime - now
        if (diff <= 0) return 0
        const days = Math.ceil(diff / (1000 * 60 * 60 * 24))
        return days
      } catch (error) {
        console.error('计算剩余天数失败:', error)
        return 0
      }
    }
  },
  mounted () {
    if (this.$route.query) {
      console.log('query', this.$route.query)
      if (this.$route.query.from === 'wxapp') {
        this.showAppBar = false
        this.phone = this.$route.query.phone
      }
      if (this.$route.query.phone) {
        this.phone = this.$route.query.phone
      }
    }
    this.loadDatas()
    this.fetchVipInfo()
  },
  methods: {
    onBack () {
      if (this.$store.state.user.qrCodeHospital === '宏乾健康') {
        this.$router.push('/hongqian/home')
      } else {
        this.$router.back()
      }
    },
    onItemClick (item) {
      if (this.$route.query.from === 'wxapp') {
        /*
        uni.navigateTo({
    url: '/pages/plan_detail/plan_detail?id=' + planItem.id,
  })
         */
        /*
        const wxJson = JSON.stringify(this.paySignInfo)
          const encodedParam = encodeURIComponent(wxJson)
         */
        // window.wx.miniProgram.navigateTo({
        //   url: '/pages/plan_detail/plan_detail?id=' + item.id
        // })
        this.$store.commit('play/setPlan', item)
        this.$router.push('/PlanDetailPage')
      } else {
        this.$store.commit('play/setPlan', item)
        this.$router.push('/PlanDetailPage')
      }
    },
    async httpDatas () {
      let datas = await PlanDao.loadList(this.phone ? this.phone : this.$store.state.user.profile.phone)

      if (!datas || datas.length === 0) {
        datas = await PlanDao.loadList('11900009101')
      }

      datas.forEach(e => {
        e.plan = JSON.parse(e.plan)
        e.gmtCreate = DateUtils.formate(e.gmtCreate, 'yyyy-MM-DD HH:mm:ss')
        console.log(e.plan)
      })

      for (const item of datas) {
        if (item.doctorId) {
          try {
            const doctorInfo = await DoctorUserDao.getDoctorInfoById(item.doctorId)
            if (doctorInfo) {
              item.doctorInfo = doctorInfo
            }
          } catch (error) {
            console.error('获取医生信息失败:', error)
          }
        }
      }

      this.datas = datas
    },
    async loadDatas () {
      this.loading = true
      this.refreshing = true
      await this.httpDatas()
      console.log('数据请求结果', this.datas)
      if (this.datas.length) {
        this.empty = false
      } else {
        this.empty = true
      }
      this.finished = true
      this.loading = false
      this.refreshing = false
    },
    async fetchVipInfo () {
      if (!this.$store.state.user.profile.isLogin) {
        this.isVipLoading = false
        return
      }

      try {
        this.isVipLoading = true
        const userId = this.$route.query.userId || sessionStorage.getItem('shunyi_user_id') || this.$store.state.user.profile.userId

        if (!userId) {
          this.vipInfo = null
          this.isVipLoading = false
          return
        }

        const vipInfo = await VipDao.getUserVipInfo(userId)
        if (vipInfo) {
          this.vipInfo = vipInfo
        } else {
          this.vipInfo = null
        }
      } catch (error) {
        console.error('获取VIP信息失败:', error)
        this.vipInfo = null
      } finally {
        this.isVipLoading = false
      }
    },
    formatVipExpireDate (endTime) {
      if (!endTime) return ''
      try {
        const normalizeTimestamp = (ts) => {
          if (!ts) return 0
          const num = Number(ts)
          return num < 1e12 ? num * 1000 : num
        }

        const timestamp = normalizeTimestamp(endTime)
        const date = new Date(timestamp)
        const year = date.getFullYear()
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const day = date.getDate().toString().padStart(2, '0')
        return `${year}-${month}-${day}`
      } catch (error) {
        console.error('格式化VIP到期日期失败:', error)
        return ''
      }
    }
  }
}
</script>

<style scoped>
.plan-list-page {
  min-height: 100vh;
  background: #f5f7fa;
}

.plan-list-page__content {
  padding-bottom: 20px;
}

/* 统计信息卡片 */
.plan-list-page__stats {
  padding: 12px 16px 0;
}

.stats-card {
  background: linear-gradient(135deg, #1989fa 0%, #0e6fd6 100%);
  border-radius: 12px;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 12px rgba(25, 137, 250, 0.2);
}

.stats-card__icon {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.stats-card__info {
  flex: 1;
  color: #fff;
}

.stats-card__value {
  font-size: 28px;
  font-weight: bold;
  line-height: 1.2;
  margin-bottom: 4px;
}

.stats-card__label {
  font-size: 14px;
  opacity: 0.9;
}

.stats-card__vip {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  color: #fff;
  margin-left: 16px;
}

.stats-card__vip-label {
  font-size: 12px;
  opacity: 0.9;
  margin-bottom: 4px;
}

.stats-card__vip-value {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 2px;
}

.stats-card__vip-days {
  font-size: 13px;
  opacity: 0.95;
}

/* 列表容器 */
.plan-list-page__list {
  padding: 0 16px;
  margin-top: 12px;
}

/* 方案项 */
.plan-item {
  position: relative;
  margin-bottom: 12px;
  transition: transform 0.2s ease;
}

.plan-item:active {
  transform: scale(0.98);
}

.plan-item__badge {
  position: absolute;
  top: -8px;
  left: 12px;
  z-index: 2;
}

.plan-item__card {
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.plan-item__card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

/* 左侧图标区域 */
.plan-item__icon-wrapper {
  margin-right: 12px;
}

.plan-item__icon {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #07c160 0%, #05a352 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(7, 193, 96, 0.2);
}

/* 内容区域 */
.plan-item__content {
  flex: 1;
  min-width: 0;
}

.plan-item__title {
  font-size: 16px;
  font-weight: 600;
  color: #323233;
  line-height: 1.4;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.plan-item__info {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.info-item {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #999;
}

.info-item__text {
  margin-left: 4px;
  line-height: 1.4;
}

/* 右侧箭头 */
.plan-item__arrow {
  margin-left: 8px;
  display: flex;
  align-items: center;
}

/* 自定义下拉刷新样式 */
:deep(.van-pull-refresh__track) {
  min-height: 100vh;
}

/* 自定义列表完成文本样式 */
:deep(.van-list__finished-text) {
  color: #969799;
  font-size: 13px;
  padding: 16px 0;
}

/* 空状态优化 */
:deep(.van-empty__description) {
  color: #969799;
  font-size: 14px;
  padding: 16px 0;
}

/* 响应式适配 */
@media screen and (max-width: 375px) {
  .plan-item__icon {
    width: 48px;
    height: 48px;
  }

  .plan-item__title {
    font-size: 15px;
  }

  .stats-card__value {
    font-size: 24px;
  }
}

/* 加载动画优化 */
:deep(.van-loading) {
  padding: 24px 0;
}

/* Tag标签样式优化 */
:deep(.van-tag--success) {
  background: linear-gradient(135deg, #07c160 0%, #05a352 100%);
  border: none;
  padding: 4px 12px;
  box-shadow: 0 2px 8px rgba(7, 193, 96, 0.2);
}
</style>
